import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import PageTransition from './components/PageTransition';
import { Layout } from './components/Layout';
import EventModal from "./components/sub-components/EventModal";
import SpecialEventModal from "./components/sub-components/SpecialEventModal";
import BandSchema from "./components/sub-components/BandSchema";
import SlideTransition from './components/sub-components/SlideTransition';
import './custom.css';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import { useState } from 'react';

const App = ({ children }) => {
    const location = useLocation();
    const [showModal, setShowModal] = useState(false);

    // Show once per day (after 5 seconds)
    useEffect(() => {
        const today = new Date().toDateString();

        if (localStorage.getItem("festivalModal") !== today) {
            const timer = setTimeout(() => {
                setShowModal(true);
                localStorage.setItem("festivalModal", today);
            }, 5000); // 5 seconds

            return () => clearTimeout(timer);
        }
    }, []);


    // Add at the top
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true';
    });

    // Initialize GA4 only once
    useEffect(() => {
        ReactGA.initialize('G-73B8WDWGW4'); // your GA4 Measurement ID
    }, []);

    // Send pageview on every route change
    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }, [location]);

    // Optional: Update Open Graph timestamp
    useEffect(() => {
        const currentDate = new Date().toISOString();
        const metaTag = document.querySelector('meta[property="og:updated_time"]');
        if (metaTag) {
            metaTag.setAttribute('content', currentDate);
        }
    }, []);

    // Destructure route groups from AppRoutes
    const { withLayout, standalone } = AppRoutes(isAuthenticated, setIsAuthenticated);

    
    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Dirty Yachtin' Scoundrels | Yacht Rock Band</title>
                <meta
                    name="description"
                    content="Dirty Yachtin' Scoundrels is a premier yacht rock band performing smooth '70s and '80s hits across the U.S."
                />
                <meta property="og:site_name" content="Dirty Yachtin' Scoundrels" />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>

            <Routes location={location}>
                {/* Standalone routes (no Layout) */}
                {standalone.map((route, index) => (
                    <Route key={index} {...route} />
                ))}

                {/* All other routes wrapped in Layout */}
                <Route
                    path="/*"
                    element={
                        <Layout>
                            <BandSchema />
                            <SlideTransition>
                                {/* Wrap all withLayout routes in a Routes */}
                                <Routes>
                                    {withLayout.map((route, index) => {
                                        const { element, ...rest } = route;
                                        return (
                                            <Route
                                                key={index}
                                                {...rest}
                                                element={React.cloneElement(element, {
                                                    isAuthenticated,
                                                    setIsAuthenticated,
                                                })}
                                            />
                                        );
                                    })}
                                </Routes>
                            </SlideTransition>
                            {/*  Modal lives here */}
                            {/*<SpecialEventModal*/}
                            {/*    show={showModal}*/}
                            {/*    onClose={() => {*/}
                            {/*        localStorage.setItem("festivalModal", new Date().toDateString());*/}
                            {/*        setShowModal(false);*/}
                            {/*    }}*/}
                            {/*/>*/}

                            {/* <EventModal /> */}
                        </Layout>
                    }
                />
            </Routes>

        </HelmetProvider>
    );

};

export default App;
